import React, { Component } from 'react'
import Select from 'react-select'
import { defineMessages, injectIntl } from 'react-intl'

const messages = defineMessages({
    "letter": {
        id: 'common.page_size.letter',
        defaultMessage: 'Letter',
    },
    "A4": {
        id: 'common.page_size.A4',
        defaultMessage: 'A4',
    },
})

class PageSizeSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: [
                { value: "letter", label: this.props.intl.formatMessage(messages["letter"]) },
                { value: "A4", label: this.props.intl.formatMessage(messages["A4"]) }
            ],
            selectedOption: this.props.value || 'letter',
        }

        const defaultCallback = () => { }
        this.onChange = this.props.onChange || defaultCallback
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            this.onChange(selectedOption.value)
        });
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.selectedOption) {
            this.setState({
                selectedOption: nextProps.value || {}
            })
        }
    }

    render() {

        return (
            <Select
                name={'pageSize'}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
                clearable={false}
            />
        )
    }
}

export default injectIntl(PageSizeSelect)





// WEBPACK FOOTER //
// ./src/common/proposal/pagesizeselect.component.jsx